// Chinese Checkers page entry.
import { ChineseCheckersGame } from "../board/chinese-checkers-ui"

const root = document.getElementById("board")
if (root) (window as unknown as { dtGame?: ChineseCheckersGame }).dtGame = new ChineseCheckersGame(root)
